import { IBaseAction, IPromiseParam } from './../base';
import { put, call, takeEvery } from 'redux-saga/effects';
import * as types from './actionTypes.config';
import * as _ from 'lodash';
import * as errorSaga from '../errors/saga.errors';
import Api from '../../api/Api';
import { IAcusticModel } from '../../models/IAcusticModel';
import { isBase64 } from '../../services/mini/isBase64';
const yaml = require('js-yaml');

const defaultConfig = JSON.stringify(
    {
        "billing_payment_forms": { contentVersion: "0.0.1", chance: 0.33 }
    });

export function* watch() {
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_FEATURES_CONFIG_REQ, getFeaturesConfig);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_STUDIO_CONFIG_REQ, getStudioConfig);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_VOICES_CONFIG_REQ, getVoicesConfig);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_REQ, getWakeWordAcusticModelsConfig);
    yield takeEvery<IPromiseParam & IBaseAction>(types.GET_SLU_VERSION_CONFIG_REQ, getSLUVersionsConfig);
}

export function* getFeaturesConfig() {
    try {
        const envFeatures = process.env.STUDIO_CONFIG;
        let features;

        try {
            features = yaml.load(isBase64(envFeatures) ? atob(envFeatures) : envFeatures);
            yield put({ type: types.GET_FEATURES_CONFIG_OK, features });
        } catch (e) {
            console.error(e);
        }

    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getStudioConfig({ resolve, reject }: IPromiseParam & IBaseAction) {
    try {
        let { config } = yield call(Api.getStudioConfig);

        try {
            config = JSON.parse(config);
            resolve(config);
        } catch (e) {
            console.log("Studio config wasn't set, default config is used");
            resolve(defaultConfig);
        }

    } catch (error) {
        yield errorSaga.putError(error);
        reject(error);
    }
}

export function* getVoicesConfig({ resolve, reject }: IPromiseParam & IBaseAction) {
    try {
        const voicesInfo = yield call(Api.getVoicesConfig);
        const voices = JSON.parse(voicesInfo.value);
        yield put({ type: types.GET_VOICES_CONFIG_OK, voices });
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* getSLUVersionsConfig({ resolve, reject }: IPromiseParam & IBaseAction) {
    try {
        let { sluVersions } = yield call(Api.getSLUVersionsConfig);
        sluVersions = sluVersions.reverse();
        yield put({ type: types.GET_SLU_VERSION_CONFIG_OK, sluVersions });
        resolve(sluVersions);
    } catch (error) {
        yield errorSaga.putError(error);
        reject();
    }
}

export function* getWakeWordAcusticModelsConfig({ resolve, reject }: IPromiseParam & IBaseAction) {
    try {
        const acousticModelsData = yield call(Api.getWakeWordAcusticModelsConfig);
        const acousticModels = JSON.parse(acousticModelsData.value) as IAcusticModel[];

        for (let i = 0; i < acousticModels.length; i++) {
            var regExp = new RegExp(/\d{8}_\d{6}/gi);
            try {
                const dateFromUrl = acousticModels[i].acoustic.match(regExp)[0];
                if (dateFromUrl) {
                    const year = +dateFromUrl.substr(0, 4);
                    const month = +dateFromUrl.substr(4, 2);
                    const day = +dateFromUrl.substr(6, 2);
                    const hours = +dateFromUrl.substr(9, 2);
                    const mins = +dateFromUrl.substr(11, 2);
                    const secs = +dateFromUrl.substr(13, 2);
                    acousticModels[i].date = new Date(year, month - 1, day, hours, mins, secs);
                }
            } catch (e) {
                acousticModels[i].date = null;
            }
        }

        yield put({ type: types.GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_OK, acousticModels });

        resolve(acousticModels);
    } catch (error) {
        yield errorSaga.putError(error);
    }
}
